<template>
    <NevsCard class="terms-card">
        <div class="logo-container">
            <img :src="logo"/>
        </div>
        <h2 class="terms-title">{{ $LANG.Get('labels.termsTitle') }}</h2>
        <p class="terms-intro">{{ introText }}</p>
        <a class="terms-link" :href="termsUrl" target="_blank" rel="noopener">
            <i class="fa-solid fa-file-contract"></i> {{ $LANG.Get('labels.termsLinkText') }}
        </a>
        <div class="terms-accept-row">
            <NevsCheckbox v-model="accepted" :label="$LANG.Get('labels.acceptTerms')"></NevsCheckbox>
        </div>
        <div class="terms-footer">
            <NevsButton class="success nevs-float-right" :class="{'terms-disabled': !accepted}" @click="acceptClick">
                <i class="fa-solid fa-check"></i> {{ $LANG.Get('buttons.proceed') }}
            </NevsButton>
        </div>
        <div class="nevs-clear-float"></div>
    </NevsCard>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";

export default {
    name: "TermsAcceptance",
    components: {NevsCard, NevsButton, NevsCheckbox},
    data() {
        return {
            logo: import.meta.env.BASE_URL + 'logo.png',
            termsUrl: 'https://fytlix.com/uvjeti_koristenja.pdf',
            accepted: false,
            submitting: false
        }
    },
    computed: {
        introText() {
            // First-time users (empty `terms`) get a welcome message; users who accepted an earlier version get
            // an "updated terms" message.
            const accepted = this.$store.state.user ? this.$store.state.user.terms : '';
            const key = (accepted === '' || accepted === null) ? 'labels.termsIntroFirst' : 'labels.termsIntroUpdate';
            return this.$LANG.Get(key);
        }
    },
    methods: {
        acceptClick() {
            if (!this.accepted || this.submitting) return;
            this.submitting = true;
            let vm = this;
            this.$API.APICall('post', 'terms/accept', {}, (data, success) => {
                vm.submitting = false;
                if (success) {
                    // Reflect the acceptance in the logged-in user so the terms gate clears and the app appears.
                    vm.$store.commit('setUser', {...vm.$store.state.user, terms: data.terms});
                    vm.$emit('accepted');
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    emits: ['accepted']
}
</script>

<style scoped>
.terms-card {
    max-width: 500px;
    margin: 40px auto;
}

.logo-container {
    text-align: center;
    border-bottom: 1px dotted #5e6278;
    margin-bottom: 15px;
}

.logo-container img {
    width: 100%;
    max-width: 250px;
}

.terms-title {
    margin: 0 0 10px;
    font-size: 20px;
}

.terms-intro {
    margin: 0 0 15px;
    font-size: 14px;
}

.terms-link {
    display: inline-block;
    margin-bottom: 20px;
    font-weight: bold;
    color: #1c4e80;
    text-decoration: none;
}

.terms-link:hover {
    text-decoration: underline;
}

.terms-accept-row {
    margin-bottom: 15px;
}

.terms-footer {
    border-top: 1px dotted #5e6278;
    padding-top: 15px;
}

.terms-disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>
